<template>
  <v-container grid-list-md>
    <v-dialog persistent v-model="dialog.show" max-width="400">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm8>
                <v-text-field
                  outline
                  v-model="dialog.language.full"
                  :label="$t('fields.fullName') + '*'"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field
                  outline
                  v-model="dialog.language.short"
                  :label="$t('fields.shortName') + '*'"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="dialogSave">{{
            $t('buttons.save')
          }}</v-btn>
          <v-btn color="error" @click="dialogClose">{{
            $t('buttons.cancel')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn @click="addItem" icon color="primary">
          <v-icon small>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-iterator
      :items="records"
      content-tag="v-layout"
      hide-actions
      row
      wrap
    >
      <v-flex slot="item" slot-scope="props" xs12 sm3 lg2>
        <v-card>
          <v-card-title
            ><h4>{{ props.item.full }}</h4></v-card-title
          >
          <v-divider></v-divider>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content
                >{{ $t('fields.shortName') }}:</v-list-tile-content
              >
              <v-list-tile-content class="align-end">{{
                props.item.short
              }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-layout row wrap>
                  <v-flex>
                    <v-btn
                      class="ma-0"
                      color="success"
                      flat
                      icon
                      @click="editItem(props.item)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      class="ma-0"
                      color="error"
                      flat
                      icon
                      @click="removeItem(props.item)"
                    >
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-data-iterator>
  </v-container>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'Languages',
  data() {
    return {
      headers: [
        { text: this.$t('fields.fullName'), value: 'full' },
        { text: this.$t('fields.shortName'), value: 'short' },
        { text: '', value: '', sortable: false },
      ],
      records: [],
      search: '',
      dialog: {
        show: false,
        language: {
          id: 0,
          full: '',
          short: '',
        },
      },
    }
  },
  methods: {
    reloadData() {
      this.$APICall(
        'get',
        'LANGUAGES',
        '',
        [],
        data => {
          this.records = data
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },
    editItem(item) {
      this.dialog.language = JSON.parse(JSON.stringify(item))
      this.dialog.show = true
    },
    removeItem(item) {
      this.$verify(this.$t('alerts.deletionQuestion'), result => {
        if (result) {
          this.$APICall(
            'delete',
            'LANGUAGES',
            '/' + item.id,
            {},
            () => {
              this.reloadData()
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },
    addItem() {
      this.dialog.language = {
        id: 0,
        full: '',
        short: '',
      }
      this.dialog.show = true
    },
    dialogClose() {
      this.dialogReset()
    },
    dialogSave() {
      let message = ''
      if (this.dialog.language.full == '') {
        message += this.$t('alerts.fullMissing') + '<br />'
      }
      if (this.dialog.language.short == '') {
        message += this.$t('alerts.shortMissing') + '<br />'
      }
      if (message == '') {
        this.$APICall(
          'post',
          'LANGUAGES',
          '',
          this.dialog.language,
          () => {
            this.dialogReset()
            this.reloadData()
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },
    dialogReset() {
      this.dialog = {
        show: false,
        language: {
          id: 0,
          full: '',
          short: '',
        },
      }
    },
  },
  mounted() {
    this.reloadData()
  },
}
</script>

<style scoped></style>
